(function ($, Drupal) {
  Drupal.behaviors.filterModal = {
    attach: function (context) {

      $('.exposed-filter-modal').each(function() {
        // Count number of selected checkboxes using params in url
        const url = window.location.href;
        const paramName = $(this).attr('id');
        const decodedUrl = decodeURIComponent(url);
        const regex = new RegExp(paramName + "\\[[^\\]]*\\]=", "g");
        const matches = decodedUrl.match(regex);
        const count = matches ? matches.length : 0;
        // Set counter number
        $(this).find('button .filter-counter-number').text(count);
      });

      $('.exposed-submit').on('click', function() {
        $('input[data-drupal-selector="edit-submit-d-nrw-service"]').click();
      });

      $('.deselect-all').on('click', function(e) {
        $(this).parent('.modal-footer').parent('.modal-content').find('.form-checkboxes input.form-checkbox').prop('checked', false);
        e.preventDefault();
      });

      $('#edit-title--3').attr('form', 'views-exposed-form-d-nrw-service-block-1');
      $('#edit-submit-d-nrw-service').attr('form', 'views-exposed-form-d-nrw-service-block-1');
      $('.text-search-wrapper input#edit-submit-d-nrw-service').attr('value', 'Suchen');

    }
  }
})(jQuery, Drupal);
